import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import moment from '../../../lib/moment.js'
import { Container, Button } from 'reactstrap'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import {
  modalAction,
  authAction,
  reportAction,
} from './../../../actions/'
import {
  modalSelector,
  authSelector,
  reportSelector,
} from './../../../selectors'
import { SearchBarHeadcount, SearchBarHeadcountFilter } from '../../../components/report/search-bar'
import { ModalMessage } from '../../../components/report/modal'
import withLayout from '../../../helpers/withLayout'
import HeadcountToday from './report-today'
import HeadcountYear from './report-year'

class HeadcountReport extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getHeadcountData.headCount')
    && JSON.stringify(get(nextProps, 'getHeadcountData.headCount')) !== JSON.stringify(prevState.headCountData)) {
      const headCountData = get(nextProps, 'getHeadcountData.headCount')
      set(tempState, 'headCountData', headCountData)
      set(tempState, 'empMovements', get(headCountData, 'empMovements'))
      set(tempState, 'empTypeTodays', get(headCountData, 'empTypeTodays'))
      set(tempState, 'empTypeYears', get(headCountData, 'empTypeYears'))
      set(tempState, 'genderTodays', get(headCountData, 'genderTodays'))
      set(tempState, 'genderYears', get(headCountData, 'genderYears'))
      set(tempState, 'levels', get(headCountData, 'levels'))
      set(tempState, 'lobList', [{ lob_name: 'All', lob_id: '' }, ...get(headCountData, 'lobList')])
      nextProps.resetHeadcount()
    }
    if (get(nextProps, 'exportHeadcountData')) {
      window.open(get(nextProps, 'exportHeadcountData'))
      nextProps.resetExportHeadcount()
    }
    return tempState
  }

  state={
    startDate: moment().subtract(11, 'months').isBefore('2018-10') ? moment('2018-10-01') : moment().subtract(11, 'months').startOf('month'),
    endDate: moment().endOf('month'),
    selectedLOB: '',
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getHeadcount(
      '',
      moment().subtract(11, 'months').isBefore('2018-10') ? moment('2018-10-01') : moment().subtract(11, 'months').startOf('month'),
      moment().endOf('month'),
      access_token)
  }

  handleDate = (type, e) => {
    switch (type) {
      case 'startDate': {
        this.setState({ startDate: e })
        break
      }
      case 'endDate': {
        this.setState({ endDate: e })
        break
      }
      default: break
    }
  }

  handleLOB = (e) => {
    this.setState({ selectedLOB: e.target.value })
  }

  handleClickApply = () => {
    if (moment(this.state.endDate).diff(moment(this.state.startDate), 'months', true) > 12) {
      this.props.showConfirm('statusMessage', 'Error', 'Date range must be less than 1 year.')
      return
    }
    const access_token = localStorage.getItem('access_token')
    this.props.getHeadcount(
      this.state.selectedLOB,
      moment(this.state.startDate).format('YYYY-MM'),
      moment(this.state.endDate).format(',YYYY-MM'),
      access_token)
  }

  selectButton = (confirmStatus, confirmType) => {
    if (confirmStatus === 200) {
      return <Button color='success' onClick={ () => this.props.hideConfirm(confirmType) }>OK</Button>
    } else if (confirmStatus === 'Error') {
      return <Button color='warning' onClick={ () => this.props.hideConfirm(confirmType) }>Try Again</Button>
    }
    return null
  }

  render() {
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsHRUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsLOBLeadUser = get(this.props, 'authData.user.is_lob_lead_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectReport.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
    || get(this.props, 'redirectReport.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    if (IsLOBLeadUser !== undefined &&
      IsHRUser !== undefined &&
      IsHRConfidentialUser !== undefined &&
      IsManagementUser !== undefined &&
      IsSystemUser !== undefined &&
      !(IsSystemUser || IsLOBLeadUser || IsHRUser || IsHRConfidentialUser || IsManagementUser)) window.location = '/home'
    const isFetching = get(this.props, 'getIsFetching')
    const confirmStatus = get(this.props, 'confirmStatus')
    const confirmType = get(this.props, 'confirmType')
    const confirmMessage = get(this.props, 'confirmMessage')

    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <ModalMessage
          hide={ () => this.props.hideConfirm(confirmType) }
          show={ confirmType === 'statusMessage' }
          type={ confirmStatus }
          message={ confirmMessage }
          button={ this.selectButton(confirmStatus, confirmType) }
        />
        <SearchBarHeadcount
          lobList={ this.state.lobList }
          exportHeadcount={ (lob_id, start_date, end_date) =>
            this.props.exportHeadcount(lob_id, start_date, end_date, localStorage.getItem('access_token')) }
        />
        { !isFetching &&
        <div>
          <HeadcountToday
            genderTodays={ this.state.genderTodays }
            empTypeTodays={ this.state.empTypeTodays }
            levels={ this.state.levels }
          />
          <br />
          <SearchBarHeadcountFilter
            startDate={ this.state.startDate }
            endDate={ this.state.endDate }
            lobList={ this.state.lobList }
            selectedLOB={ this.state.selectedLOB }
            handleLOB={ this.handleLOB }
            handleDate={ this.handleDate }
            handleClickApply={ this.handleClickApply }
          />
          <br />
          <HeadcountYear
            genderYears={ this.state.genderYears }
            empTypeYears={ this.state.empTypeYears }
            empMovements={ this.state.empMovements }
          />
        </div>}
      </Wrapper>
    )
  }
}
HeadcountReport.propTypes = {
  hideConfirm: PropTypes.func.isRequired,
  getAuth: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
  getHeadcount: PropTypes.func.isRequired,
  exportHeadcount: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectReport: reportSelector.redirectReport,
  getIsFetching: reportSelector.getIsFetching,
  getHeadcountData: reportSelector.getHeadcountData,
  exportHeadcountData: reportSelector.exportHeadcountData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getHeadcount: reportAction.getHeadcountReport,
  resetHeadcount: reportAction.resetGetHeadcountReport,
  exportHeadcount: reportAction.exportHeadcountReport,
  resetExportHeadcount: reportAction.resetExportHeadcountReport,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(withLayout(HeadcountReport))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
  overflow-y: scroll ;
  max-height: 100%;
  width: 100%;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/report/headcount/index.js